import { Check, Minus } from 'lucide-react'

import { cn } from '@/utils'

interface TFLSidebarDeleteHeaderProps {
  selectedCount: number
  totalCount: number
  isSelectAll: boolean
  onSelectAllChange: () => void
}

export const TFLSidebarDeleteHeader = ({
  selectedCount,
  totalCount,
  isSelectAll,
  onSelectAllChange,
}: TFLSidebarDeleteHeaderProps) => {
  return (
    <div className="p-md flex justify-between items-center min-h-11">
      <span className="text-sm font-semibold text-primary-900">
        {selectedCount} file(s) selected
      </span>
      <button
        type="button"
        className="flex gap-2 cursor-pointer items-center p-1 bg-transparent border-none"
        onClick={onSelectAllChange}
        aria-label={isSelectAll ? 'Deselect all files' : 'Select all files'}
        aria-pressed={isSelectAll}
      >
        <span>Select all</span>
        <div
          className={cn(
            'size-4 rounded-xs flex items-center justify-center',
            'border border-solid border-primary',
            selectedCount
              ? 'bg-brand-solid border-transparent'
              : 'bg-transparent'
          )}
        >
          {selectedCount === totalCount ? (
            <Check size={12} className="text-white" />
          ) : (
            <Minus size={12} className="text-white" />
          )}
        </div>
      </button>
    </div>
  )
}
